import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { LegacyBaseApiService } from '@smartera/core';

@Injectable()
export class DynamicFormService extends LegacyBaseApiService<any> {
	override get apiUrl() {
		return `${Urls.BASE_URL.toString()}/callcenter/dynamic-forms`;
	}
}
